import type { AgentMode } from '../types';
import type { ThemeTokens } from './theme';

export const colors = {
  gitlabRed: '#e2432a',
  gitlabOrange: '#fc6d27',
  gitlabYellow: '#fca326',
  gitlabPurple: '#554488',
  gitlabGrey: '#8c929d',

  white: '#FFFFFF',
};

export const getAgentColor = (tokens: ThemeTokens, agent?: AgentMode): string =>
  (agent && tokens.text.agent[agent]) ?? tokens.text.default;

const AGENT_PREFIXES: Record<AgentMode, string> = {
  build: '> ',
  plan: '* ',
};

export const getAgentPrefix = (agent?: AgentMode): string =>
  (agent && AGENT_PREFIXES[agent]) ?? '- ';
